/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontFeaturedSection_seller$ref: FragmentReference;
export type StorefrontFeaturedSection_seller = {|
  +sellerPreferences: ?{|
    +urlLabel: ?string
  |},
  +$refType: StorefrontFeaturedSection_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerPreferences",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bc08d8a399155d5520d7651d9b726063';
module.exports = node;
